"use strict";

exports.__esModule = true;
var _WidgetPalette = require("./WidgetPalette");
Object.keys(_WidgetPalette).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetPalette[key]) return;
  exports[key] = _WidgetPalette[key];
});
var _WidgetPaletteItem = require("./WidgetPaletteItem");
Object.keys(_WidgetPaletteItem).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _WidgetPaletteItem[key]) return;
  exports[key] = _WidgetPaletteItem[key];
});